function configs(labels, datasets, showPercent = true, showHours = false) {
  const maxValue = Math.max(...datasets.flatMap((item) => item.data || []));

  return {
    data: {
      labels,
      datasets: datasets.map((item) => ({
        label: item.label,
        backgroundColor: item.backgroundColor,
        data: item.data,
        borderRadius: 4,
        maxBarThickness: 40,
      })),
    },

    options: {
      responsive: true,
      maintainAspectRatio: false,

      plugins: {
        legend: {
          display: false,
        },
      },

      scales: {
        y: {
          beginAtZero: true,
          min: 0,
          max: Math.ceil(maxValue / 10) * 10,

          ticks: {
            stepSize: 10,
            color: "#000",
            callback: (value) => (showPercent ? `${value}%` : showHours ? `${value} Hrs` : value),
          },

          grid: {
            color: "#e0e0e0",
          },
        },

        x: {
          ticks: {
            color: "#000",
            maxRotation: 45,
            minRotation: 45,
          },

          grid: {
            display: false,
          },
        },
      },
    },
  };
}

export default configs;
